module.exports = __webpack_public_path__ + "img/image_6.d89e0c42.jpg";